// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateGlobalVariableCommand } from '../models';
// @ts-ignore
import type { GlobalVariableViewModel } from '../models';
// @ts-ignore
import type { UpdateGlobalVariableCommand } from '../models';
/**
 * GlobalVariablesApi - axios parameter creator
 * @export
 */
export const GlobalVariablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesNameGet: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiGlobalVariablesNameGet', 'name', name)
            const localVarPath = `/api/global-variables/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {UpdateGlobalVariableCommand} [updateGlobalVariableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesNamePut: async (name: string, updateGlobalVariableCommand?: UpdateGlobalVariableCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiGlobalVariablesNamePut', 'name', name)
            const localVarPath = `/api/global-variables/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlobalVariableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateGlobalVariableCommand} [createGlobalVariableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesPost: async (createGlobalVariableCommand?: CreateGlobalVariableCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/global-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGlobalVariableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalVariablesApi - functional programming interface
 * @export
 */
export const GlobalVariablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalVariablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGlobalVariablesNameGet(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalVariableViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGlobalVariablesNameGet(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalVariablesApi.apiGlobalVariablesNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {UpdateGlobalVariableCommand} [updateGlobalVariableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGlobalVariablesNamePut(name: string, updateGlobalVariableCommand?: UpdateGlobalVariableCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalVariableViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGlobalVariablesNamePut(name, updateGlobalVariableCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalVariablesApi.apiGlobalVariablesNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateGlobalVariableCommand} [createGlobalVariableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGlobalVariablesPost(createGlobalVariableCommand?: CreateGlobalVariableCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalVariableViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGlobalVariablesPost(createGlobalVariableCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalVariablesApi.apiGlobalVariablesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalVariablesApi - factory interface
 * @export
 */
export const GlobalVariablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalVariablesApiFp(configuration)
    return {
        /**
         * 
         * @param {GlobalVariablesApiApiGlobalVariablesNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesNameGet(requestParameters: GlobalVariablesApiApiGlobalVariablesNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel> {
            return localVarFp.apiGlobalVariablesNameGet(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GlobalVariablesApiApiGlobalVariablesNamePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesNamePut(requestParameters: GlobalVariablesApiApiGlobalVariablesNamePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel> {
            return localVarFp.apiGlobalVariablesNamePut(requestParameters.name, requestParameters.updateGlobalVariableCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GlobalVariablesApiApiGlobalVariablesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGlobalVariablesPost(requestParameters: GlobalVariablesApiApiGlobalVariablesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel> {
            return localVarFp.apiGlobalVariablesPost(requestParameters.createGlobalVariableCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalVariablesApi - interface
 * @export
 * @interface GlobalVariablesApi
 */
export interface GlobalVariablesApiInterface {
    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApiInterface
     */
    apiGlobalVariablesNameGet(requestParameters: GlobalVariablesApiApiGlobalVariablesNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel>;

    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesNamePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApiInterface
     */
    apiGlobalVariablesNamePut(requestParameters: GlobalVariablesApiApiGlobalVariablesNamePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel>;

    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApiInterface
     */
    apiGlobalVariablesPost(requestParameters?: GlobalVariablesApiApiGlobalVariablesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVariableViewModel>;

}

/**
 * Request parameters for apiGlobalVariablesNameGet operation in GlobalVariablesApi.
 * @export
 * @interface GlobalVariablesApiApiGlobalVariablesNameGetRequest
 */
export interface GlobalVariablesApiApiGlobalVariablesNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GlobalVariablesApiApiGlobalVariablesNameGet
     */
    readonly name: string
}

/**
 * Request parameters for apiGlobalVariablesNamePut operation in GlobalVariablesApi.
 * @export
 * @interface GlobalVariablesApiApiGlobalVariablesNamePutRequest
 */
export interface GlobalVariablesApiApiGlobalVariablesNamePutRequest {
    /**
     * 
     * @type {string}
     * @memberof GlobalVariablesApiApiGlobalVariablesNamePut
     */
    readonly name: string

    /**
     * 
     * @type {UpdateGlobalVariableCommand}
     * @memberof GlobalVariablesApiApiGlobalVariablesNamePut
     */
    readonly updateGlobalVariableCommand?: UpdateGlobalVariableCommand
}

/**
 * Request parameters for apiGlobalVariablesPost operation in GlobalVariablesApi.
 * @export
 * @interface GlobalVariablesApiApiGlobalVariablesPostRequest
 */
export interface GlobalVariablesApiApiGlobalVariablesPostRequest {
    /**
     * 
     * @type {CreateGlobalVariableCommand}
     * @memberof GlobalVariablesApiApiGlobalVariablesPost
     */
    readonly createGlobalVariableCommand?: CreateGlobalVariableCommand
}

/**
 * GlobalVariablesApi - object-oriented interface
 * @export
 * @class GlobalVariablesApi
 * @extends {BaseAPI}
 */
export class GlobalVariablesApi extends BaseAPI implements GlobalVariablesApiInterface {
    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApi
     */
    public apiGlobalVariablesNameGet(requestParameters: GlobalVariablesApiApiGlobalVariablesNameGetRequest, options?: RawAxiosRequestConfig) {
        return GlobalVariablesApiFp(this.configuration).apiGlobalVariablesNameGet(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesNamePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApi
     */
    public apiGlobalVariablesNamePut(requestParameters: GlobalVariablesApiApiGlobalVariablesNamePutRequest, options?: RawAxiosRequestConfig) {
        return GlobalVariablesApiFp(this.configuration).apiGlobalVariablesNamePut(requestParameters.name, requestParameters.updateGlobalVariableCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GlobalVariablesApiApiGlobalVariablesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalVariablesApi
     */
    public apiGlobalVariablesPost(requestParameters: GlobalVariablesApiApiGlobalVariablesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return GlobalVariablesApiFp(this.configuration).apiGlobalVariablesPost(requestParameters.createGlobalVariableCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

